import { useI18n } from '../../i18n/i18n';
import type { AgeMode } from '../guest/guest-state';
import { LocalDataDialogButton } from '../guest/LocalDataPanel';
import { BunnyPicture, RocketPicture } from './pictures';
import { ReadAloudButton } from './read-aloud';

/**
 * "Who is playing?" (ADR 0017): two big pictures instead of a birth date. "Little" (3–8) gets
 * pictures, very large buttons and read-aloud; "bigger" (9+) gets titles and more choice. It is
 * the town's welcome (with the local-saving note) and can be changed at any time from the header.
 */
export function WhoIsPlaying({
  onChoose,
  showDataNote = true,
  headingLevel = 2,
}: {
  onChoose: (mode: AgeMode) => void;
  showDataNote?: boolean;
  headingLevel?: 1 | 2;
}) {
  const { t } = useI18n();
  const Heading = headingLevel === 1 ? 'h1' : 'h2';
  return (
    <section className="who-is-playing" aria-labelledby="who-title" data-testid="welcome">
      <Heading id="who-title">{t('kids.who.title')}</Heading>
      <div className="who-is-playing__choices">
        <button
          type="button"
          className="age-choice age-choice--little"
          onClick={() => onChoose('little')}
        >
          <BunnyPicture />
          <span className="age-choice__name">{t('kids.little')}</span>
          <span className="age-choice__ages">{t('kids.littleAges')}</span>
        </button>
        <button
          type="button"
          className="age-choice age-choice--bigger"
          onClick={() => onChoose('bigger')}
        >
          <RocketPicture />
          <span className="age-choice__name">{t('kids.bigger')}</span>
          <span className="age-choice__ages">{t('kids.biggerAges')}</span>
        </button>
      </div>
      <ReadAloudButton text={t('kids.who.say')} slow className="read-aloud read-aloud--labelled" />
      {showDataNote && (
        <div className="who-is-playing__data">
          <p>{t('data.body')}</p>
          <LocalDataDialogButton variant="quiet" />
        </div>
      )}
    </section>
  );
}
